import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap, catchError } from 'rxjs';
import { TraceIdService } from '../traceService/trace-id.service';

export const traceInterceptor: HttpInterceptorFn = (req, next) => {
    const traceIdService = inject(TraceIdService);

    const previousTraceId = traceIdService.currentTraceId;
    if (previousTraceId) {
        req = req.clone({
            setHeaders: { 'X-Previous-Trace-Id': previousTraceId }
        });
    }

    return next(req).pipe(
        tap({
            next: (event) => {
                if ('headers' in event && event.headers) {
                    const traceId = event.headers.get('X-Trace-Id');
                    if (traceId) {
                        traceIdService.setTraceId(traceId);
                    }
                }
            }
        }),
        catchError((error) => {
            if (error instanceof HttpErrorResponse && error.headers) {
                const traceId = error.headers.get('X-Trace-Id');
                if (traceId) {
                    traceIdService.setTraceId(traceId);
                }
            }
            throw error;
        })
    );
};
